import { STICKY_FOOTER_SPACER_ID } from "../constants.js";
import { useEffect } from "react";
import { useTheme } from "@bookingcom/bui-react";
const useStickFooterSpacerHeight = (elementRef, spacerId = STICKY_FOOTER_SPACER_ID) => {
    const theme = useTheme();
    useEffect(() => {
        const createSpace = () => {
            if (elementRef.current) {
                setSpacerHeight(spacerId, `calc(${elementRef.current.offsetHeight}px + ${theme.units.spacing_4x})`);
            }
        };
        createSpace();
        window.addEventListener("resize", createSpace);
        return () => {
            setSpacerHeight(spacerId, "");
            window.removeEventListener("resize", createSpace);
        };
    }, [elementRef, theme.units.spacing_4x, spacerId]);
};
const setSpacerHeight = (id, height) => {
    const spacer = document.getElementById(id);
    if (spacer) {
        spacer.style.height = height;
    }
};
export default useStickFooterSpacerHeight;
